var _ref, _defineProperty2;

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import '../Charts.scss';
import * as d3 from 'd3';
import React, { Component } from 'react';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { BaseMixin } from '../Mixins/BaseMixin';
import { CapMixin } from '../Mixins/CapMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import { CoordinateGridMixin } from '../Mixins/CoordinateGridMixin';
import { MarginsMixin } from '../Mixins/MarginsMixin';
import PropTypes from 'prop-types';
import { TileMixin } from '../Mixins/TileMixin';
import dc from 'dc';
import { withAVIDashboardContext } from '../../Context/AVIDashboard/AVIDashboard';
/**
 * BarChart class is and abstract class that other BarChars are extending.
 */

export var SeriesLineChart = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SeriesLineChart, _Component);

  function SeriesLineChart(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.chartRef = React.createRef();
    _this.chart = null;
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = SeriesLineChart.prototype;

  _proto.getChart = function getChart() {
    return this.chart;
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        seriesAccessor = _this$props.seriesAccessor,
        keyAccessor = _this$props.keyAccessor,
        valueAccessor = _this$props.valueAccessor,
        seriesSort = _this$props.seriesSort,
        x = _this$props.x,
        xAxisLabel = _this$props.xAxisLabel,
        yAxisLabel = _this$props.yAxisLabel,
        elasticX = _this$props.elasticX,
        elasticY = _this$props.elasticY,
        brushOn = _this$props.brushOn,
        mouseZoomable = _this$props.mouseZoomable;
    this.chart = dc.seriesChart(this.chartRef.current);
    BaseMixin(this.chart, this.props);
    CapMixin(this.chart, this.props);
    ColorMixin(this.chart, this.props);
    MarginsMixin(this.chart, this.props);
    CoordinateGridMixin(this.chart, this.props);
    TileMixin(this.chart, this.props);
    this.chart.useViewBoxResizing(true).chart(function (c) {
      return new dc.lineChart(c).curve(d3.curveCardinal);
    }).x(x).elasticX(false).brushOn(brushOn).yAxisLabel(yAxisLabel).xAxisLabel(xAxisLabel).clipPadding(10).elasticY(elasticY).elasticX(elasticX).mouseZoomable(mouseZoomable).seriesAccessor(seriesAccessor).keyAccessor(keyAccessor).valueAccessor(valueAccessor).seriesSort(seriesSort);
    this.chart.legend(dc.legend().x(this.chart.width() - this.chart.margins().right - 100).y(this.chart.margins().top).itemHeight(13).gap(5).legendWidth(100).itemWidth(100));
    this.chart.yAxis().tickFormat(function (d) {
      return d3.format(',d')(d);
    });
    this.chart.margins().left += 40;
    this.chart.render();

    if (this.props.register) {
      this.props.register(this.chart, this.props.name);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.unregister) {
      this.props.unregister(this.chart, this.props.name);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.group !== this.props.group || prevProps.dimension !== this.props.dimension) {
      this.chart.dimension(this.props.dimension).group(this.props.group).redraw();
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: this.props.showTools,
      toolsComponent: this.props.toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: 'avi-chart chart series-line-chart',
      ref: this.chartRef
    }));
  };

  return SeriesLineChart;
}(Component);

_defineProperty(SeriesLineChart, "defaultProps", (_defineProperty2 = {
  seriesAccessor: function seriesAccessor(d) {
    return d.key[0];
  },
  keyAccessor: function keyAccessor(d) {
    return +d.key[1];
  },
  valueAccessor: function valueAccessor(d) {
    return +d.value;
  },
  seriesSort: function seriesSort(a, b) {
    if (!a || !b) return 0;
    return a > b ? 1 : b < a ? -1 : 0;
  },
  renderLabel: true,
  brushOn: true,
  x: d3.scaleLinear().domain([0, 20]),
  elasticX: false,
  elasticY: true
}, _defineProperty2["brushOn"] = true, _defineProperty2.mouseZoomable = false, _defineProperty2));

SeriesLineChart.propTypes = process.env.NODE_ENV !== "production" ? (_ref = {
  /** Chart title */
  chartTitle: PropTypes.string,

  /** Crossfilter dimension that returns an array where the first element is the series name and the second is the x-value */
  dimension: PropTypes.object.isRequired,

  /** Crossfilter group with a single value that represents the y-value of each point in the line*/
  group: PropTypes.object.isRequired,

  /** Function used to access the series, if the dimension looks different from what is written in the documentation, change */
  seriesAccessor: PropTypes.func,

  /** Function used to access the series, if the dimension looks different from what is written in the documentation, change */
  keyAccessor: PropTypes.func,

  /** Function used to access the series, if the dimension looks different from what is written in the documentation, change */
  valueAccessor: PropTypes.func,

  /** Turn on/off label rendering */
  renderLabel: PropTypes.bool,

  /** Get or set an accessor to order ordinal dimensions. The chart uses crossfilter.quicksort.by to sort elements; this accessor returns the value to order on. */
  seriesSort: PropTypes.func,

  /** Display brush selector on non orindal charts ?  */
  brushOn: PropTypes.bool,

  /** Set the margins for a particular coordinate grid chart instance. The margins is stored as array. */
  margins: PropTypes.array,

  /** Set the x axis label. */
  xAxisLabel: PropTypes.string,

  /** Set the y-axis label */
  yAxisLabel: PropTypes.string,

  /** Specify an X-axis */
  x: PropTypes.func.isRequired,

  /** Make X-axis elastic */
  elasticX: PropTypes.bool,

  /** Make Y-axis elastic */
  elasticY: PropTypes.bool
}, _ref["brushOn"] = PropTypes.bool, _ref.mouseZoomable = PropTypes.bool, _ref) : {};
export default withAVIDashboardContext(SeriesLineChart);